import angular from 'angular'
import routers from './routers.js'
import stampDutyTaskTrackingCtrl from './stampDutyTaskTrackingCtrl.js'

export default angular
  .module('declaration.stampDuty.stampDutyTaskTracking', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('stampDutyTaskTrackingCtrl', stampDutyTaskTrackingCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/stampDuty/stampDutyTaskTracking/index.js